/*eslint-disable no-unused-vars*/
import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import arrayUtil from './utils/arrayUtil';
import loader from './utils/loader';
import { canOpenPage } from './utils/permission';

const moment = require('moment-timezone');

Vue.use(Router);

const withPrefix = (prefix, routes) =>
  routes.map((route) => {
    route.path = prefix + route.path;
    if (route.alias) route.alias = prefix + route.alias;
    return route;
  });

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'login',
      component: loader.view('Login'),
      meta: {
        guest: true,
        layout: 'basic',
      },
    },
    ...withPrefix('/provider', [
      {
        path: '/list',
        alias: '/',
        name: 'provider',
        component: require('./views/Provider/Provider.vue').default,
        meta: {
          auth: true,
          childOf: 'provider',
          headerName: 'Provider',
        },
      },
      {
        path: '/archived',
        name: 'providerArchived',
        component: loader.subpage('Provider', 'ProviderArchived'),
        meta: {
          auth: true,
          childOf: 'provider',
          headerName: 'Provider Archived',
        },
      },
      {
        path: '/provider-type',
        name: 'providerType',
        component: loader.subpage('Provider', 'ProviderType'),
        meta: {
          auth: true,
          childOf: 'provider',
          headerName: 'Provider Type',
        },
      },
      {
        path: '/provider-performance',
        name: 'providerPerformance',
        component: loader.subpage('Provider', 'ProviderPerformance'),
        meta: {
          auth: true,
          childOf: 'provider',
          headerName: 'Provider Performance Adjustment',
        },
      },
      {
        path: '/provider-transaction',
        name: 'providerTransaction',
        component: loader.subpage('Provider', 'ProviderTransaction'),
        meta: {
          auth: true,
          childOf: 'provider',
          headerName: 'Provider Transaction',
        },
      },
      {
        path: '/provider-type/:id',
        name: 'providerTypeDetail',
        component: require('./views/Provider/ProviderTypeDetail/ProviderTypeDetail.vue').default,
        meta: {
          auth: true,
          childOf: 'provider',
          extendedToolbar: true,
          headerName: 'Provider Type Detail',
        },
      },
      {
        path: '/:id',
        name: 'providerProfile',
        component: require('./views/Provider/ProviderProfiles.vue').default,
        meta: {
          auth: true,
          childOf: 'provider',
          extendedToolbar: true,
          headerName: 'Provider Profile',
        },
      },
    ]),
    ...withPrefix('/voucher', [
      {
        path: '/list',
        alias: '/',
        name: 'voucher',
        component: loader.subpage('Voucher', 'Voucher'),
        meta: {
          auth: 'true',
          childOf: 'voucher',
          headerName: 'Voucher',
        },
      },
      {
        path: '/order',
        name: 'voucherOrder',
        component: loader.subpage('Voucher', 'VoucherOrder'),
        meta: {
          auth: 'true',
          childOf: 'voucher',
          headerName: 'Voucher Order',
        },
      },
    ]),
    {
      path: '/coupon',
      name: 'coupon',
      component: loader.view('Coupon'),
      meta: {
        auth: 'true',
        headerName: 'Coupon',
      },
    },
    {
      path: '/patient',
      name: 'patient',
      component: loader.subpage('Patient', 'Patient'),
      meta: {
        headerName: 'Patient',
        auth: true,
      },
    },
    {
      path: '/wallet-order',
      name: 'wallet-order',
      component: loader.subpage('WalletOrder', 'WalletOrder'),
      meta: {
        headerName: 'Wallet Order',
        auth: true,
      },
    },
    {
      path: '/notification',
      name: 'notification',
      component: loader.view('Notification'),
      meta: {
        headerName: 'Notification',
        auth: true,
        childOf: 'notifications',
        legacyPermissionKey: 'notification',
      },
    },
    {
      path: '/special-days',
      name: 'specialDays',
      component: loader.view('SpecialDays'),
      meta: {
        headerName: 'ปฏิทินวันพิเศษ',
        auth: true,
        childOf: 'notifications',
      },
    },
    ...withPrefix('/prescription', [
      {
        path: '/list',
        name: 'prescriptionList',
        component: loader.subpage('Prescription', 'PrescriptionList'),
        meta: {
          auth: true,
          childOf: 'prescription',
          headerName: 'Prescription List',
        },
      },
      {
        path: '/medicines',
        name: 'medicines',
        component: loader.subpage('Prescription', 'MedicineList'),
        meta: {
          auth: true,
          childOf: 'prescription',
          headerName: 'Medicines',
        },
      },
      {
        path: '/b2b-discount',
        name: 'B2BDiscount',
        component: loader.subpage('Prescription', 'B2BDiscount'),
        meta: {
          auth: true,
          childOf: 'prescription',
          headerName: 'B2B Discount',
        },
      },
    ]),
    {
      path: '/sendSms',
      name: 'sendSms',
      component: loader.view('SendSms'),
      meta: {
        auth: 'true',
        headerName: 'SMS',
      },
    },
    {
      path: '/assessment',
      name: 'assessment',
      component: loader.view('Assessment'),
      meta: {
        auth: 'true',
        headerName: 'Assessment',
      },
    },
    // ...withPrefix('/billytest', [
    //   {
    //     path: '/billytestchild1',
    //     name: 'billytestchild1',
    //     component: loader.view('BillyTestChild1'),
    //     meta: {
    //       auth: true,
    //       childOf: 'billytest',
    //       headerName: 'Billy Test Child 1',
    //     },
    //   },
    //   {
    //     path: '/billytestchild2',
    //     name: 'billytestchild2',
    //     component: loader.view('BillyTestChild2'),
    //     meta: {
    //       auth: true,
    //       childOf: 'billytest',
    //       headerName: 'Billy Test Child 2',
    //     },
    //   },
    // ]),
    ...withPrefix('/assessments', [
      {
        path: '/B2cAssessments',
        name: 'b2cAssessments',
        component: loader.subpage('Assessments', 'B2cAssessments'),
        meta: {
          auth: true,
          childOf: 'assessments',
          headerName: 'B2C Assessments',
        },
      },
      {
        path: '/B2bAssessments',
        name: 'b2bAssessments',
        component: loader.subpage('Assessments', 'B2bAssessments'),
        meta: {
          auth: true,
          childOf: 'assessments',
          headerName: 'B2B Assessments',
        },
      },
    ]),
    ...withPrefix('/chat', [
      {
        path: '/chat_system_prompt',
        name: 'chatSystemPrompt',
        component: loader.view('ChatSystemPrompt'),
        meta: {
          auth: 'true',
          childOf: 'chat',
          headerName: 'Chat System Prompt',
        },
      },
      {
        path: '/chatroom',
        name: 'chatroom',
        component: loader.view('ChatRoom'),
        meta: {
          auth: 'true',
          childOf: 'chat',
          headerName: 'Chat Rooms',
        },
      },
    ]),
    {
      path: '/user_blocked_provider',
      name: 'userBlockedProvider',
      component: loader.view('UserBlockedProvider'),
      meta: {
        auth: 'true',
        headerName: 'User Blocked Provider',
      },
    },
    {
      path: '/user_management',
      name: 'userManagement',
      component: loader.view('UserManagement'),
      meta: {
        auth: 'true',
        headerName: 'User Management',
      },
    },
    {
      path: '/permission',
      name: 'permission',
      component: loader.view('Permission'),
      meta: {
        auth: 'true',
        headerName: 'Permission Management',
      },
    },
    {
      path: '/newAppointment',
      name: 'newAppointment',
      component: loader.view('NewAppointment'),
      meta: {
        headerName: 'Create a new appointment',
        auth: 'true',
      },
    },
    {
      path: '/homefeed',
      name: 'homefeed',
      component: loader.view('HomeFeed'),
      meta: {
        headerName: 'Home Feed',
        auth: 'true',
      },
    },
    ...withPrefix('/corporate', [
      {
        path: '',
        alias: '/list',
        name: 'corporate',
        component: loader.subpage('Corporate', 'Corporate'),
        meta: {
          auth: true,
          childOf: 'corporate',
          headerName: 'Corporate',
        },
      },
      {
        path: '/:id',
        name: 'corporateProfile',
        component: loader.subpage('Corporate', 'CorporateProfiles'),
        meta: {
          auth: true,
          childOf: 'corporate',
          extendedToolbar: false,
          headerName: 'Corporate Profile',
        },
      },
    ]),
    ...withPrefix('/report', [
      {
        path: '/all-appointment',
        name: 'allAppointment',
        component: loader.subpage('Report', 'AllAppointment'),
        meta: {
          auth: true,
          childOf: 'report',
          headerName: 'All Appointment',
        },
      },
    ]),
    ...withPrefix('/calendar', [
      {
        path: '/provider-schedule',
        name: 'providerSchedule',
        component: loader.subpage('Calendar', 'ProviderSchedule'),
        meta: {
          auth: true,
          childOf: 'calendar',
          headerName: "Provider's Schedule",
        },
      },
      {
        path: '/appointment',
        name: 'appointmentSchedule',
        component: loader.subpage('Calendar', 'AppointmentSchedule'),
        meta: {
          auth: true,
          childOf: 'calendar',
          headerName: 'Appointment Schedule',
        },
      },
    ]),
    {
      path: '/404',
      name: 'notFound',
      component: loader.view('ErrorPage'),
      meta: {
        error: {
          code: 404,
          message: 'PAGE NOT FOUND',
        },
        layout: 'basic',
      },
    },
    {
      path: '/401',
      name: 'notAuthorized',
      component: loader.view('ErrorPage'),
      meta: {
        error: {
          code: 401,
          message: 'NOT AUTHORIZED',
        },
        layout: 'basic',
      },
    },
    {
      path: '/email-blast/templates',
      name: 'EmailBlastTemplates',
      component: require('./views/EmailBlast/Templates.vue').default,
      meta: { auth: true, permissionKey: 'sendSms', headerName: 'Email Blast Templates' },
    },
    {
      path: '/email-blast/templates/new',
      name: 'EmailBlastTemplateNew',
      component: require('./views/EmailBlast/TemplateNew.vue').default,
      meta: { auth: true, permissionKey: 'sendSms', headerName: 'New Email Template' },
    },
    {
      path: '/email-blast/templates/:id/edit',
      name: 'EmailBlastTemplateEdit',
      component: require('./views/EmailBlast/TemplateEdit.vue').default,
      meta: { auth: true, permissionKey: 'sendSms', headerName: 'Edit Email Template' },
    },
    {
      path: '/email-blast/send',
      name: 'EmailBlastSend',
      component: require('./views/EmailBlast/Send.vue').default,
      meta: { auth: true, permissionKey: 'sendSms', headerName: 'Send Email Blast' },
    },
    { path: '*', redirect: '/404' },
  ],
});

router.beforeEach((to, from, next) => {
  store
    .dispatch('setting/checkOrSet')
    .then((configAuthorized) => {
      let hasValidRole = undefined;
      const permKey = to.meta.permissionKey || to.name;
      if (to.meta.childOf) {
        hasValidRole =
          configAuthorized[to.meta.childOf] &&
          configAuthorized[to.meta.childOf][to.name] &&
          configAuthorized[to.meta.childOf][to.name].authType &&
          store.state.auth.roles
            ? arrayUtil.intersect(store.state.auth.roles, configAuthorized[to.meta.childOf][to.name].authType)[0]
            : undefined;
      } else {
        if (configAuthorized[permKey]) {
          hasValidRole =
            configAuthorized[permKey] && configAuthorized[permKey].authType && store.state.auth.roles
              ? arrayUtil.intersect(store.state.auth.roles, configAuthorized[permKey].authType)[0]
              : undefined;
        } else {
          hasValidRole = undefined;
        }
      }
      if (
        !hasValidRole &&
        to.meta.legacyPermissionKey &&
        canOpenPage(configAuthorized, store.state.auth.roles || [], { key: to.meta.legacyPermissionKey })
      ) {
        hasValidRole = true;
      }
      const isAuthenticated = store.state.auth.authenticated;
      const isAuthRoute = to.matched.some((m) => m.meta.auth);
      const isGuestRoute = to.matched.some((m) => m.meta.guest);

      if (isAuthRoute) {
        if (isAuthenticated && hasValidRole) {
          store.dispatch('auth/setLastActiveTime', moment());
          next();
        } else if (isAuthenticated && !hasValidRole) {
          console.log('isAuthenticated:', isAuthenticated, 'hasValidRole:', hasValidRole);
          const redirectName = 'notAuthorized';
          const redirect = {
            name: redirectName,
          };
          next(redirect);
        } else {
          console.log('isAuthenticated:', isAuthenticated, 'hasValidRole:', hasValidRole);
          const redirectName = 'login';
          let redirectQuery = to.query.redirect;
          if (!redirectQuery) {
            redirectQuery = to.path;
          }
          const redirect = {
            name: redirectName,
            query: {
              redirect: redirectQuery,
            },
          };
          if (to.query) {
            redirect.params = {
              query: to.query,
            };
          }
          console.log(redirect);
          next(redirect);
          return;
        }
      }

      if (isGuestRoute && isAuthenticated && hasValidRole) {
        const redirectName = configAuthorized.startPage[hasValidRole] || 'allAppointment';
        next({
          name: redirectName,
        });
        return;
      }
      next();
    })
    .catch((error) => {});
});

export default router;
